import { render, staticRenderFns } from "./Novo-Stock-actualizado.vue?vue&type=template&id=5e02bc06&scoped=true&"
import script from "./Novo-Stock-actualizado.vue?vue&type=script&lang=js&"
export * from "./Novo-Stock-actualizado.vue?vue&type=script&lang=js&"
import style0 from "./Novo-Stock-actualizado.vue?vue&type=style&index=0&id=5e02bc06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02bc06",
  null
  
)

export default component.exports